import React from "react";
import { useRouter } from "next/router";

import {
  AUDIENCE_TYPES_ARRAY,
  getAudienceBySlug,
  getAudienceSlug,
} from "posts/constants";
import ProfilePage from "components/ProfilePage";

export async function getStaticProps() {
  return {
    props: {
      baseUrl: process.env.BASE_URL,
    },
  };
}

export async function getStaticPaths() {
  const slugs = AUDIENCE_TYPES_ARRAY.map((audienceType) =>
    getAudienceSlug(audienceType)
  );
  return {
    paths: slugs.map((narrativeType) => ({
      params: { slug: narrativeType },
    })),
    fallback: false,
  };
}

export default function Profile({ baseUrl }) {
  const router = useRouter();
  const { slug } = router.query;
  const audience = getAudienceBySlug(slug);

  return <ProfilePage baseUrl={baseUrl} currentAudience={audience} />;
}
